import styles from './SPCards.module.scss'

const SPCards: React.FC = () => {
  return (
    <section className={styles.sp_cards}>
      <section className={styles.UIUX_card}>
        <img src="/images/img/service/img_service_uiux.jpg" alt="uiuxLP" className={styles.img} />
        <div className={styles.text_wrapper}>
          <span className={styles.sub_title}>UX/UIサービス</span>
          <p className={styles.title}>共に考え 共に創る デザインパートナー</p>
          <p className={styles.text}>
            私たちは徹底したデザイン思考でアプリやウェブサイトを利用したビジネスを成功へとつなげます。
          </p>
          <a className={styles.button} href="uiuxdesign-lp2" target="_blank" rel="noopener">
            詳細はこちら
          </a>
        </div>
      </section>
      <section className={styles.pictureWrapper}>
        <div className={styles.lineText}>
          <p className={styles.marquee}>Business Design Technology</p>
        </div>
        <div>
          <div className={`${styles.redBox} ${styles.Left}`}></div>
          <div className={`${styles.redBox} ${styles.Right}`}></div>
          <img className={styles.imgLeft} src="/images/lp2/gallery_img_1.png" alt="gallery" />
          <img className={styles.imgRight} src="/images/lp2/gallery_img_2.png" alt="gallery" />
        </div>
      </section>
    </section>
  )
}

export default SPCards
